const assetsMenu: any = {
  order: 7,
  id: "assets",
  title: "Assets",
  translate: "MENU.ASSETS",
  type: "collapsible",
  icon: "box",
  capability: "show_menu_asset",
  children: [
    {
      id: "assets-list",
      title: "Lista",
      translate: "LIST",
      type: "item",
      capability: "show_list_asset",
      url: "dashboard/assets/list",
    },
    {
      id: "asset_categories",
      title: "Categorie",
      translate: "MENU.ASSET_CATEGORIES",
      type: "item",
      capability: "show_categories_asset",
      url: "dashboard/asset/categories_list",
    },
    {
      id: "assets-documents",
      title: "Lettere",
      translate: "MENU.DOCUMENTS",
      type: "item",
      capability: "show_assets_document",
      url: "dashboard/documents/assets-list",
    },
    {
      id: "assets-import",
      title: "Import",
      translate: "IMPORT",
      type: "item",
      capability: "asset_import",
      url: "dashboard/assets/import",
    },
  ],
};
export default assetsMenu;
